var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isAuthenticated
    ? _c(
        "v-app-bar",
        { attrs: { dark: "", app: "", "clipped-left": "" } },
        [
          _c("v-app-bar-nav-icon", {
            staticClass: "d-flex",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$emit("toggle-nav")
              },
            },
          }),
          _c(
            "div",
            { staticClass: "d-none d-md-inline-block" },
            [
              _c("v-img", {
                attrs: {
                  flat: "",
                  to: "/modelpipeline",
                  width: "160px",
                  height: "50px",
                  "aspect-ratio": "1.710",
                  contain: "",
                  src: require("@/assets/stratus_logo.png"),
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-inline-block d-md-none" },
            [
              _c("v-img", {
                attrs: {
                  width: "160px",
                  height: "50px",
                  "aspect-ratio": "1.710",
                  contain: "",
                  src: require("@/assets/stratus_logo.png"),
                },
              }),
            ],
            1
          ),
          _c("bread-crumbs"),
          _c("v-spacer", { staticClass: "d-none d-sm-flex" }),
          _c(
            "v-badge",
            {
              attrs: {
                bordered: _vm.notificationBadge > 0,
                overlap: "",
                color: _vm.notificationBadge > 0 ? "error" : "transparent",
                value: _vm.notificationBadge,
                content:
                  _vm.notificationBadge > 9 ? "9+" : _vm.notificationBadge,
                "offset-x": "25",
                "offset-y": "25",
              },
            },
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "", disabled: _vm.notificationBadge === 0 },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("toggle-notifications")
                    },
                  },
                },
                [_c("v-icon", [_vm._v("notifications")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-btn",
            { attrs: { icon: "" }, on: { click: _vm.toggleTheme } },
            [
              _c("v-icon", [
                _vm._v(_vm._s(_vm.isDarkTheme ? "light_mode" : "dark_mode")),
              ]),
            ],
            1
          ),
          _c(
            "v-menu",
            {
              attrs: { bottom: "", left: "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function ({ on }) {
                      return [
                        _c(
                          "v-btn",
                          { attrs: { text: "" } },
                          [
                            _c(
                              "v-avatar",
                              _vm._g(
                                {
                                  attrs: { color: "red darken-2", size: "35" },
                                },
                                on
                              ),
                              [
                                _vm.avatarImage && _vm.avatarImage.length > 0
                                  ? _c("v-img", {
                                      attrs: { src: _vm.avatarImage },
                                    })
                                  : _c("span", [
                                      _vm._v(_vm._s(_vm.avatarInitials)),
                                    ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                4264731243
              ),
            },
            [
              _c(
                "v-list",
                [
                  _c(
                    "v-list-item",
                    [
                      _c(
                        "v-btn",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.$emit("logout")
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("lock")]), _vm._v(" Log Out")],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-list-item", { staticClass: "caption" }, [
                    _vm._v(" API Version: " + _vm._s(_vm.version) + " "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "v-app-bar",
        { attrs: { app: "", dark: "", "clipped-left": "" } },
        [
          _c(
            "div",
            { staticClass: "d-none d-md-inline-block mr-4" },
            [
              _c("v-img", {
                attrs: {
                  flat: "",
                  width: "80px",
                  "aspect-ratio": "1.710",
                  contain: "",
                  src: require("@/assets/stratus_logo.png"),
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-inline-block d-md-none mr-4" },
            [
              _c("v-img", {
                attrs: {
                  width: "50px",
                  height: "160px",
                  "aspect-ratio": "1.710",
                  contain: "",
                  src: require("@/assets/stratus_logo.png"),
                },
              }),
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "v-toolbar-items",
            [
              _c(
                "v-menu",
                {
                  attrs: { bottom: "", left: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on }) {
                        return [
                          _c(
                            "v-btn",
                            _vm._g({ attrs: { text: "" } }, on),
                            [_c("v-icon", [_vm._v("account_circle")])],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "v-list",
                    [
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-btn",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("login")
                                },
                              },
                            },
                            [
                              _c("v-icon", [_vm._v("input")]),
                              _vm._v(" Log In"),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }